module.exports = __webpack_public_path__ + "img/project-example-1.641ac6df.jpg";